Wee.fn.make('cfpd', {
	init: function() {
		var scope = this,
			hash = $.routes.uri().hash;

		scope.$items = $('ref:cfpdItem');

		scope.bindEvents();
	},

	/**
	 * Bind all events
	 */
	bindEvents: function() {
		var scope = this;

		scope.$items.on('click.cfpd', function(e, el) {
			scope.toggleTarget(el, true);
		});

		$.screen.map([
			{
				min: 1,
				max: 4,
				each: true,
				callback: function() {
					if (scope.index > -1) {
						scope.toggleTarget(scope.$items[scope.index]);
					}
				}
			}
		]);
	},

	/**
	 * Remove any open detail slides
	 */
	removeTarget: function() {
		$('.js-cfpd-details').remove();
	},

	/**
	 * Open target detail slide
	 *
	 * @param {HTMLElement} el
	 * @param {Boolean} clicked
	 */
	toggleTarget: function(el, clicked) {
		var $el = $(el),
			data = $.get('cfpdData'),
			index = $el.data('index'),
			$target = $('<div class="cfpd-training__details js-cfpd-details js-cfpd-' + index + '" />'),
			size = $.screen.size(),
			columns = this.getColumnCount(),
			pos;

		this.index = index;

		// If clicking on the same item, remove that specific detail
		if (clicked && this.targetExists(el)) {
			$('.js-cfpd-' + index).remove();
		} else {
			// Otherwise, remove any open detail and open specified detail
			this.removeTarget();

			$target.html($.view.render('cfpdDetail', {
				title: data[index].title,
				body: data[index].body
			}));

			if (columns === 1) {
				$target.insertAfter($el);
			} else if (columns >= 2) {
				pos = (Math.ceil((index + 1) / columns) * columns) - 1;

				if (pos === this.$items.length) {
					pos = pos - columns;
				}

				if (pos >= 0) {
					$target.insertAfter(this.$items.eq(pos));
				}
			}

			Wee.animate.tween($($._body), {
				scrollTop: $('.js-cfpd-' + index).offset().top - 100
			});
		}
	},

	/**
	 * Check to see if current target exists
	 *
	 * @param  {HTMLElement} el
	 * @return {Boolean}
	 */
	targetExists: function(el) {
		return $('.js-cfpd-' + $(el).data('index')).length;
	},

	/**
	 * Get the column count based on the current screen size
	 *
	 * @return {Number}
	 */
	getColumnCount: function() {
		var size = $.screen.size();

		if (size < 3) {
			return 1;
		} else if (size === 3) {
			return 2;
		} else if (size > 3) {
			return 3;
		}
	}
});
